var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoqStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main-svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1856,
    height: 820,
    viewBox: "0 0 1856 820",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YardLayout",
    transform: "translate(-34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1856,
    height: 820,
    transform: "translate(34)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PointMachine",
    "data-name": "Point Machine",
    transform: "translate(450.398 172.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM132",
    className: "tooltip",
    transform: "translate(43.974 165.97)",
    "edge-id": "NOQ_PM_132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM132Hr",
    transform: "translate(32.448 6.205) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_132Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM132Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_132Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM132Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_132Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM132Icon",
    transform: "translate(17.447 3.03)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_132Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM132Label",
    transform: "translate(16.447 27.03)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_132Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "132")), /*#__PURE__*/React.createElement("path", {
    id: "PM132Line",
    d: "M0,26.888H0L20.393.5h6.794",
    transform: "translate(0 -1.505)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_132Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM131",
    className: "tooltip",
    transform: "translate(0 191.97)",
    "edge-id": "NOQ_PM_131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM131Hr",
    transform: "translate(0 10.952) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_131Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM131Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_131Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM131Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_131Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM131Icon",
    transform: "translate(13.665 6.276)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_131Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM131Label",
    transform: "translate(8.665 40.276)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_131Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "131")), /*#__PURE__*/React.createElement("path", {
    id: "PM131Line",
    d: "M20.784.5h0L4.059,24.817H-2.667",
    transform: "translate(22.628 -0.505)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_131Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM114",
    className: "tooltip",
    transform: "translate(455.629 436.527)",
    "edge-id": "NOQ_PM_114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM114Hr",
    transform: "translate(0 14.809) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_114Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM114Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_114Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM114Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_114Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM114Icon",
    transform: "translate(9.331 11.633)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_114Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM114Label",
    transform: "translate(4.973 44.875)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_114Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "114")), /*#__PURE__*/React.createElement("path", {
    id: "PM114Line",
    d: "M23.615.956h0L.882,30.659H-13.431",
    transform: "translate(22.987 -0.956)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_114Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM136",
    className: "tooltip",
    transform: "translate(253.82)",
    "edge-id": "NOQ_PM_136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM136Hr",
    transform: "translate(43.843 21.175) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_136Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM136Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_136Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM136Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_136Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM136Icon",
    transform: "translate(28.842 18)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_136Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM136Label",
    transform: "translate(23.842 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_136Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "136")), /*#__PURE__*/React.createElement("path", {
    id: "PM136Line",
    d: "M40.634-.751H24.325L-2.9,27.035h0",
    transform: "translate(2.287 15.174)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_136Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM135",
    className: "tooltip",
    transform: "translate(196.329 45.616)",
    "edge-id": "NOQ_PM_135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM135Hr",
    transform: "translate(0 17.306) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_135Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM135Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_135Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM135Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_135Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM135Icon",
    transform: "translate(9.33 13.63)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_135Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM135Label",
    transform: "translate(10.665 42.63)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_135Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "135")), /*#__PURE__*/React.createElement("path", {
    id: "PM135Line",
    d: "M-3.094,32.3H15.917L48.331-1.174h0",
    transform: "translate(7.759 -1.444)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_135Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM106",
    className: "tooltip",
    transform: "translate(482.331 2)",
    "edge-id": "NOQ_PM_106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM106Hr",
    transform: "translate(0 26.302) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_106Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM106Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_106Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM106Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_106Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM106Icon",
    transform: "translate(10.331 22)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_106Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM106Label",
    transform: "translate(3.331 9)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_106Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "106")), /*#__PURE__*/React.createElement("path", {
    id: "PM106Line",
    d: "M39.679,27.151h0L8.61-1.088H-4.012",
    transform: "translate(13.987 18.784)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_106Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM105",
    className: "tooltip",
    transform: "translate(536.664 48.387)",
    "edge-id": "NOQ_PM_105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM105Hr",
    transform: "translate(46.466 11.035) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_105Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM105Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_105Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM105Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_105Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM105Icon",
    transform: "translate(30.465 5.274)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_105Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM105Label",
    transform: "translate(31.465 39.859)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_105Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "105")), /*#__PURE__*/React.createElement("path", {
    id: "PM105Line",
    d: "M-3.765,0h0l30.3,23.666H38.523",
    transform: "translate(3.765)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_105Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM134",
    className: "tooltip",
    transform: "translate(132.61 62.924)",
    "edge-id": "NOQ_PM_134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM134Hr",
    transform: "translate(67.458 25.175) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_134Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM134Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_134Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM134Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_134Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM134Icon",
    transform: "translate(52.457 22)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_134Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM134Label",
    transform: "translate(48.457 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_134Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "134")), /*#__PURE__*/React.createElement("path", {
    id: "PM134Line",
    d: "M-9.178,35.759h0L44.263-3.851H56.972",
    transform: "translate(9.178 22.951)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_134Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM133",
    className: "tooltip",
    transform: "translate(64.329 121.875)",
    "edge-id": "NOQ_PM_133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM133Hr",
    transform: "translate(0 20.047) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_133Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM133Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_133Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM133Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_133Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM133Icon",
    transform: "translate(10.665 16.371)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_133Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM133Label",
    transform: "translate(9.665 13.371)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_133Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "133")), /*#__PURE__*/React.createElement("path", {
    id: "PM133Line",
    d: "M49.134,0h0L3.546,34.808H-9.178",
    transform: "translate(18.773)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_133Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM104",
    className: "tooltip",
    transform: "translate(753.331 83.022)",
    "edge-id": "NOQ_PM_104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM104Hr",
    transform: "translate(0 8.28) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_104Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM104Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_104Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM104Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_104Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM104Icon",
    transform: "translate(10.331 3.978)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_104Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM104Label",
    transform: "translate(9.331 27.978)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_104Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "104")), /*#__PURE__*/React.createElement("path", {
    id: "PM104Line",
    d: "M50.916,36.889h0L18.909-1.961H8.066",
    transform: "translate(2.596 1.961)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_104Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM103",
    className: "tooltip",
    transform: "translate(806.963 121.983)",
    "edge-id": "NOQ_PM_103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM103Hr",
    transform: "translate(42.166 21.2) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_103Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM103Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_103Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM103Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_103Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM103Icon",
    transform: "translate(28.165 18.024)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_103Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM103Label",
    transform: "translate(24.165 51.024)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_103Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "103")), /*#__PURE__*/React.createElement("path", {
    id: "PM103Line",
    d: "M8.322,0h0L39.975,35.466h10.06",
    transform: "translate(-8.322)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_103Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM102",
    className: "tooltip",
    transform: "translate(840.795 165.997)",
    "edge-id": "NOQ_PM_102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM102Hr",
    transform: "translate(0 8.305) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_102Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM102Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_102Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM102Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_102Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM102Icon",
    transform: "translate(10.331 4.003)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_102Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM102Label",
    transform: "translate(9.331 28.003)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_102Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "102")), /*#__PURE__*/React.createElement("path", {
    id: "PM102Line",
    d: "M56.507,22.249h0l-.639-.4L16.674-4.915H3.468",
    transform: "translate(7.634 4.915)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_102Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM101",
    className: "tooltip",
    transform: "translate(905.098 193.287)",
    "edge-id": "NOQ_PM_101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM101Hr",
    transform: "translate(57.003 8.671) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_101Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM101Hr1",
    d: "M4.657,8.755C2.154,7.007.841,5.417.3,4.086-1.141.519,2.98-1.187,4.658.919c1.677-2.106,5.8-.4,4.355,3.167C8.475,5.417,7.161,7.007,4.657,8.755Z",
    "edge-id-selector": "NOQ_PM_101Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM101Hr2",
    d: "M0,1.235H0l2.715.014L3.091,0,4.785,2.681,5.4,1.119l3.341.116",
    transform: "translate(0.302 2.163)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_101Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM101Icon",
    transform: "translate(40.958 5.475)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_101Icon"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.522,
    cy: 7.55,
    rx: 7.522,
    ry: 7.55,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.522,
    cy: 7.55,
    rx: 5.522,
    ry: 5.55,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM101Label",
    transform: "translate(39.955 39.627)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_101Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "101")), /*#__PURE__*/React.createElement("path", {
    id: "PM101Line",
    d: "M2.442-3.065,18.682,6.78,42.6,21.285H58.5",
    transform: "translate(-2.442 3.065)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_101Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM108",
    className: "tooltip",
    transform: "translate(498.851 251.246)",
    "edge-id": "NOQ_PM_108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM108Hr",
    transform: "translate(0 16.176) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_108Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM108Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_108Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM108Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_108Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM108Icon",
    transform: "translate(7.999 13)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_108Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM108Label",
    transform: "translate(7.999 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_108Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "108")), /*#__PURE__*/React.createElement("path", {
    id: "PM108Line",
    d: "M24.066,0h0L.869,28.566H-6.94",
    transform: "translate(18.251 3.089)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_108Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM107",
    className: "tooltip",
    transform: "translate(541.432 206)",
    "edge-id": "NOQ_PM_107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM107Hr",
    transform: "translate(35.899 26.175) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_107Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM107Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_107Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM107Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_107Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM107Icon",
    transform: "translate(20.23 23)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_107Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM107Label",
    transform: "translate(20.23 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_107Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "107")), /*#__PURE__*/React.createElement("path", {
    id: "PM107Line",
    d: "M-5.737,28.267h0L15.559,0h9.61",
    transform: "translate(5.737 19.769)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_107Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM115",
    className: "tooltip",
    transform: "translate(471.652 272)",
    "edge-id": "NOQ_PM_115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM115Hr",
    transform: "translate(39.867 25.175) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_115Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM115Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_115Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM115Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_115Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM115Icon",
    transform: "translate(24.198 22)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_115Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM115Label",
    transform: "translate(11.198 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_115Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "115")), /*#__PURE__*/React.createElement("path", {
    id: "PM115Line",
    d: "M-4.987,28.548h0L20.943,0H30.58",
    transform: "translate(4.987 18.651)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_115Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM116",
    className: "tooltip",
    transform: "translate(420.851 319.3)",
    "edge-id": "NOQ_PM_116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM116Hr",
    transform: "translate(0 12.817) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_116Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM116Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_116Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM116Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_116Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM116Icon",
    transform: "translate(2.499 9.641)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_116Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM116Label",
    transform: "translate(1.499 42.641)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_116Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "116")), /*#__PURE__*/React.createElement("path", {
    id: "PM116Line",
    d: "M30.257,0h0L4.563,27.6h-9.55",
    transform: "translate(20.438)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_116Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM137",
    className: "tooltip",
    transform: "translate(25.665 205.924)",
    "edge-id": "NOQ_PM_137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM137Hr",
    transform: "translate(0 26.175) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_137Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM137Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_137Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM137Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_137Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM137Icon",
    transform: "translate(17.831 23)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_137Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM137Label",
    transform: "translate(16.831 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_137Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "137")), /*#__PURE__*/React.createElement("path", {
    id: "PM137Line",
    d: "M31.456,22.518h0L12.843,0H-.143",
    transform: "translate(19.473 19.991)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_137Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM138",
    className: "tooltip",
    transform: "translate(77.015 248.919)",
    "edge-id": "NOQ_PM_138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM138Hr",
    transform: "translate(43.144 19.003) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_138Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM138Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_138Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM138Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_138Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM138Icon",
    transform: "translate(27.143 16.327)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_138Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM138Label",
    transform: "translate(25.143 13.327)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_138Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "138")), /*#__PURE__*/React.createElement("path", {
    id: "PM138Line",
    d: "M6.485,0h0l29.9,33.772H46.808",
    transform: "translate(-6.485)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_138Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM111",
    className: "tooltip",
    transform: "translate(605.715 286.918)",
    "edge-id": "NOQ_PM_111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM111Hr",
    transform: "translate(69.826 7.636) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_111Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM111Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_111Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM111Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_111Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM111Icon",
    transform: "translate(54.157 4.461)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_111Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM111Label",
    transform: "translate(24.157 11.588)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_111Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "111")), /*#__PURE__*/React.createElement("path", {
    id: "PM111Line",
    d: "M-15.845,54.887h0l57.7-53.4h14.58",
    transform: "translate(15.845 -1.487)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_111Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM113",
    className: "tooltip",
    transform: "translate(502.392 410.857)",
    "edge-id": "NOQ_PM_113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM113Hr",
    transform: "translate(38.458 5.479) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_113Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM113Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_113Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM113Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_113Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM113Icon",
    transform: "translate(21.457 2.303)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_113Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM113Label",
    transform: "translate(21.457 27.303)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_113Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "113")), /*#__PURE__*/React.createElement("path", {
    id: "PM113Line",
    d: "M-10.721,26.849h0L10.135,1.409H25.674",
    transform: "translate(10.721 -1.409)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_113Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM112",
    className: "tooltip",
    transform: "translate(472.849 340.853)",
    "edge-id": "NOQ_PM_112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM112Hr",
    transform: "translate(38.001 50.483) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_112Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM112Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_112Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM112Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_112Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM112Icon",
    transform: "translate(21 47.307)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_112Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM112Label",
    transform: "translate(0 59.307)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_112Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "112")), /*#__PURE__*/React.createElement("path", {
    id: "PM112Line",
    d: "M101.316.3l-.853.784L35.192,66.314H-15.845",
    transform: "translate(30.928 -0.3)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_PM_112Line"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM109",
    className: "tooltip",
    transform: "translate(689.872 265.75)",
    "edge-id": "NOQ_PM_109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM109Hr",
    transform: "translate(16.669 3.175) rotate(-0.286)",
    "edge-id-selector": "NOQ_PM_109Hr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PM109Hr1",
    d: "M4.643,8.7C2.147,6.961.837,5.381.3,4.059-1.138.515,2.971-1.179,4.643.913c1.673-2.092,5.782-.4,4.343,3.146C8.449,5.381,7.14,6.961,4.643,8.7Z",
    "edge-id-selector": "NOQ_PM_109Hr1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PM109Hr2",
    d: "M0,1.227H0l2.707.014L3.082,0l1.69,2.663L5.39,1.112l3.331.116",
    transform: "translate(0.3 2.149)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    "edge-id-selector": "NOQ_PM_109Hr2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PM109Icon",
    transform: "translate(1)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_109Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM109Label",
    transform: "translate(0 31.5)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_109Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "109"))), /*#__PURE__*/React.createElement("g", {
    id: "PM18X",
    className: "tooltip",
    transform: "translate(68.602 269.122)",
    "edge-id": "NOQ_PM_18X"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PM18XIcon",
    transform: "translate(5.413)",
    fill: "#fff",
    stroke: "#6c7091",
    strokeWidth: 4,
    "edge-id-selector": "NOQ_PM_18XIcon"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PM18XLabel",
    transform: "translate(0 30.279)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_PM_18XLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18X")))), /*#__PURE__*/React.createElement("g", {
    id: "Shunt",
    transform: "translate(298.7 147.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGC3",
    className: "tooltip",
    transform: "translate(1259.36 245.117) rotate(-0.286)",
    "edge-id": "NOQ_SG_C3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC3Label",
    transform: "translate(0 35.755)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_C3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C-3")), /*#__PURE__*/React.createElement("g", {
    id: "SGC3Aspect",
    transform: "translate(14.118 11.39)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_C3Aspect"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES",
    transform: "translate(9.146)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1",
    y2: 16.333,
    transform: "translate(24.586)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2",
    x2: 10,
    transform: "translate(14.501 16.28)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3",
    x2: 5,
    transform: "translate(0 16.23)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGC46",
    className: "tooltip",
    transform: "translate(24.149 185.044) rotate(179.714)",
    "edge-id": "NOQ_SG_C46"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGC46Label",
    transform: "translate(23.963 23.552) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_C46Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C-46")), /*#__PURE__*/React.createElement("g", {
    id: "SGC46Aspect",
    transform: "translate(1.997 11.437)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_C46Aspect"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-2",
    "data-name": "POLES"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-2",
    "data-name": "POLES1",
    y2: 16.333,
    transform: "translate(16.585)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-2",
    "data-name": "POLES2",
    x2: 5,
    transform: "translate(11.5 16.358)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES3-2",
    "data-name": "POLES3",
    x2: 2,
    transform: "translate(0 16.309)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SH14",
    className: "tooltip",
    transform: "translate(611.3 66.028)",
    "edge-id": "NOQ_SG_SH14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole",
    transform: "translate(0 20.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH14Pole1",
    y1: 14.719,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH14Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH14Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH14Pole2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH14Label",
    transform: "translate(1.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH14Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-14")), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.601 7.875)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SGS14Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(9.156 15.851) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SGS14Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(9.156 21.882) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SGS14Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(16.24 18.867) rotate(-0.286)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH18",
    className: "tooltip",
    transform: "translate(527.3 336.112)",
    "edge-id": "NOQ_SG_SH18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-2",
    "data-name": "Pole",
    transform: "translate(0 22.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH18Pole1",
    y1: 14.719,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH18Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH18Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH18Pole2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH18Label",
    transform: "translate(0.24 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH18Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-18")), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.601 9.721)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH18Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.036 17.768) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH18Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH18Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.036 23.799) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH18Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH18Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(15.12 20.783) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH18Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH20",
    className: "tooltip",
    transform: "translate(527.3 392.112)",
    "edge-id": "NOQ_SG_SH20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-3",
    "data-name": "Pole",
    transform: "translate(0 23.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH18Pole1-2",
    "data-name": "SH18Pole1",
    y1: 14.719,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH18Pole2-2",
    "data-name": "SH18Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH20Label",
    transform: "translate(0 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH20Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-20")), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.601 9.721)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH20Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.701 17.768) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH20Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH20Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.701 23.799) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH20Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH20Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(15.785 20.783) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH20Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH22",
    className: "tooltip",
    transform: "translate(526.54 457.112)",
    "edge-id": "NOQ_SG_SH22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-4",
    "data-name": "Pole",
    transform: "translate(0.76 22.776)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH22Pole1",
    y1: 14.719,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH22Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH22Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH22Pole2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH22Label",
    transform: "translate(0 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH22Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-22")), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.361 9.067)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH22Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.916 16.768) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH22Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH22Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.916 22.799) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH22Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH22Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(16 19.783) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH22Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH12",
    className: "tooltip",
    transform: "translate(716.453 148.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-5",
    "data-name": "Pole",
    transform: "translate(3.847 22.429)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH12Pole1",
    y1: 14.719,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH12Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH12Label",
    transform: "translate(0 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-12")), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(9.448 8.72)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH12Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(12.003 16.697) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH12Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(12.003 22.728) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH12Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(19.087 19.712) rotate(-0.286)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH44",
    className: "tooltip",
    transform: "translate(47.027 206)",
    "edge-id": "NOQ_SG_SH44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-6",
    "data-name": "Pole",
    transform: "translate(1.273 23.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH44Pole1",
    y1: 14.719,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH44Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH44Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH44Pole2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH44Label",
    transform: "translate(0 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH44Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-44")), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.36 9.791)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH44Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.309 17.88) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH44Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH44Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.309 23.911) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH44Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH44Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(15.393 20.895) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH44Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH39",
    className: "tooltip",
    transform: "translate(330.333 311.412)",
    "edge-id": "NOQ_SG_SH39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-7",
    "data-name": "Pole",
    transform: "translate(20.408)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH39Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH39Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH39Pole2",
    y1: 5,
    transform: "translate(0 13.117) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH39Pole2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH39Label",
    transform: "translate(0 31.498)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH39Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-39")), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(1.771 -0.663)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH39Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(12.003 7.467) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH39Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH39Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(12.003 13.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH39Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH39Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(5.003 9.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH39Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH37",
    className: "tooltip",
    transform: "translate(486.741 102.412)",
    "edge-id": "NOQ_SG_SH37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-8",
    "data-name": "Pole",
    transform: "translate(24)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH37Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH37Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH37Pole2",
    y1: 5,
    transform: "translate(0 13.117) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH37Pole2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH37Label",
    transform: "translate(0 30.493)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH37Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-37")), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(4.638 -3.471)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH37Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14.595 4.467) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH37Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH37Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14.595 10.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH37Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH37Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(7.595 6.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH37Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH16",
    className: "tooltip",
    transform: "translate(546.267)",
    "edge-id": "NOQ_SG_SH16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-9",
    "data-name": "Pole",
    transform: "translate(6.033 23.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH41Pole1",
    y1: 14.719,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH41Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH16Label",
    transform: "translate(0 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH16Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-16")), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(11.634 10.903)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH16Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14.069 18.88) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH16Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH16Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14.069 24.88) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH16Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH16Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(22.069 21.88) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH16Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH7",
    className: "tooltip",
    transform: "translate(1091.741 185.202)",
    "edge-id": "NOQ_SG_SH7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-10",
    "data-name": "Pole",
    transform: "translate(18)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH7Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH17Pole2",
    y1: 5,
    transform: "translate(0 13.117) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH7Label",
    transform: "translate(0 32.477)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH7Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-7")), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(-0.913 -0.663)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH7Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(9.595 6.678) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH7Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH7Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(9.595 12.709) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH7Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH7Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(2.595 8.709) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH7Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH9",
    className: "tooltip",
    transform: "translate(971.741 310.94)",
    "edge-id": "NOQ_SG_SH9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-11",
    "data-name": "Pole",
    transform: "translate(18)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH7Pole1-2",
    "data-name": "SH7Pole1",
    y1: 24.738,
    x2: 0.059,
    transform: "translate(6)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SHPole2",
    y1: 5,
    transform: "translate(0 17.379) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH9Label",
    transform: "translate(0 39.812)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH9Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-9")), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(-0.912 3.599)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH9Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(9.595 10.94) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH9Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH9Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(9.595 16.971) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH9Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH9Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(3.595 12.971) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH9Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH41",
    className: "tooltip",
    transform: "translate(500.291 39.412)",
    "edge-id": "NOQ_SG_SH41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-12",
    "data-name": "Pole",
    transform: "translate(18.45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH41Pole1-2",
    "data-name": "SH41Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH41Pole1-2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH41Pole2-2",
    "data-name": "SH41Pole2",
    y1: 5,
    transform: "translate(0 13.117) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH41Pole2-2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH41Label",
    transform: "translate(0 33.493)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH41Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-41")), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(-0.912 -0.663)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH41Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(10.045 7.467) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH41Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH41Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(10.045 13.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH41Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH41Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(3.045 9.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH41Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH35",
    className: "tooltip",
    transform: "translate(304.741 245.412)",
    "edge-id": "NOQ_SG_SH35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-13",
    "data-name": "Pole",
    transform: "translate(22)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH39Pole1-2",
    "data-name": "SH39Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH39Pole2-2",
    "data-name": "SH39Pole2",
    y1: 5,
    transform: "translate(0 13.117) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH35Label",
    transform: "translate(0 33.869)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH35Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-35")), /*#__PURE__*/React.createElement("path", {
    id: "Path_99-2",
    "data-name": "Path 99",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(3.363 -0.663)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH35Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14.595 7.467) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH35Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH35Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14.595 13.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH35Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH35Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(7.595 9.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH35Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH10",
    className: "tooltip",
    transform: "translate(508.3 272.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-14",
    "data-name": "Pole",
    transform: "translate(0 22.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH10Pole1",
    y1: 14.719,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH10Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH10Label",
    transform: "translate(0.24 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-10")), /*#__PURE__*/React.createElement("path", {
    id: "Path_95-2",
    "data-name": "Path 95",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.601 9.721)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH10Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.036 17.768) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH10Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(8.036 23.799) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH10Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(15.12 20.783) rotate(-0.286)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH43",
    className: "tooltip",
    transform: "translate(294.741 185.751)",
    "edge-id": "NOQ_SG_SH43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-15",
    "data-name": "Pole",
    transform: "translate(20.408)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH43Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH43Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH43Pole2",
    y1: 5,
    transform: "translate(0 13.117) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH43Pole2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH43Label",
    transform: "translate(0 31.498)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH43Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-43")), /*#__PURE__*/React.createElement("path", {
    id: "Path_99-3",
    "data-name": "Path 99",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(1.771 -0.663)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH43Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(12.003 7.467) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH43Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH43Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(12.003 13.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH43Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH43Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(5.003 9.498) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH43Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SH24",
    className: "tooltip",
    transform: "translate(177.358 270.388)",
    "edge-id": "NOQ_SG_SH24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-16",
    "data-name": "Pole",
    transform: "translate(0 22.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "SH24Pole1",
    y1: 15.549,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH24Pole1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SH24Pole2",
    y2: 4.942,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2,
    "edge-id-selector": "NOQ_SG_SH24Pole2"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH24Label",
    transform: "translate(0.182 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SH24Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SH-24")), /*#__PURE__*/React.createElement("path", {
    id: "Path_95-3",
    "data-name": "Path 95",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(5.543 9.721)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH24Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(7.978 17.768) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH24Aspect3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH24Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(7.978 23.799) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH24Aspect2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "SH24Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(15.062 20.783) rotate(-0.286)",
    "edge-id-selector": "NOQ_SG_SH24Aspect1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "DSH_L2",
    className: "tooltip",
    transform: "translate(662.04 205.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-17",
    "data-name": "Pole",
    transform: "translate(4.259 24.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "DSHL2Pole1",
    y1: 14.719,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "DSHL2Pole2",
    y2: 5,
    transform: "translate(0 0.281) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "DSH_L2Label",
    transform: "translate(0 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DSH_L2")), /*#__PURE__*/React.createElement("path", {
    id: "Path_95-4",
    "data-name": "Path 95",
    d: "M18.366,11.075v-.442l-4.64-2.709L11.3,6.279H.913V21.138H18.366V10.158",
    transform: "translate(9.86 11.721)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "DSH_L2Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(12.295 19.768) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "DSH_L2Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(12.295 25.799) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "DSH_L2Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(19.379 22.783) rotate(-0.286)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "DSH_L10",
    className: "tooltip",
    transform: "translate(136.967 311.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pole-18",
    "data-name": "Pole",
    transform: "translate(22.774)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "DSH_L10Pole1",
    x1: 0.284,
    y1: 20.476,
    transform: "translate(5.716)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "DSH_L10Pole2",
    y1: 5,
    transform: "translate(0 13.117) rotate(-90)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "DSH_L10Label",
    transform: "translate(27 29.498)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DSH_L10")), /*#__PURE__*/React.createElement("path", {
    id: "Path_99-4",
    "data-name": "Path 99",
    d: "M.913,16.343h0V16.8l7.06,4.34h10.39V6.279H.913V16.343",
    transform: "translate(4.137 -0.663)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "DSH_L10Aspect3",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14.369 7.467) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "DSH_L10Aspect2",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(14.369 13.498) rotate(-0.286)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "DSH_L10Aspect1",
    cx: 2.981,
    cy: 3,
    rx: 2.981,
    ry: 3,
    transform: "translate(7.369 9.498) rotate(-0.286)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Signal",
    transform: "translate(138.426 148.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SGS41",
    className: "tooltip",
    transform: "translate(629.331 40.186) rotate(-0.286)",
    "edge-id": "NOQ_SG_S41"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS41Label",
    transform: "translate(0 23.969)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S41Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-41")), /*#__PURE__*/React.createElement("g", {
    id: "SGS41Aspect2",
    transform: "translate(0.067)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S41Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.478,
    cy: 7.5,
    rx: 7.478,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.478,
    cy: 7.5,
    rx: 6.728,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS41Aspect1",
    transform: "translate(15.1 0.079)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S41Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.478,
    cy: 7.5,
    rx: 7.478,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.478,
    cy: 7.5,
    rx: 6.728,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS14",
    className: "tooltip",
    transform: "translate(796.536 65.531) rotate(-0.286)",
    "edge-id": "NOQ_SG_S14"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS14Label",
    transform: "translate(11.987 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S14Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-14")), /*#__PURE__*/React.createElement("g", {
    id: "SGS14Aspect1-2",
    "data-name": "SGS14Aspect1",
    transform: "translate(0 11.967)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S14Aspect1-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 7.5,
    rx: 7.282,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 7.5,
    rx: 6.532,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS14Aspect2-2",
    "data-name": "SGS14Aspect2",
    transform: "translate(14.639 12.046)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S14Aspect2-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 7.5,
    rx: 7.282,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.282,
    cy: 7.5,
    rx: 6.532,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS37",
    className: "tooltip",
    transform: "translate(614.566 100.215) rotate(-0.286)",
    "edge-id": "NOQ_SG_S37"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS37Label",
    transform: "translate(0 25.047)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S37Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-37")), /*#__PURE__*/React.createElement("g", {
    id: "SGS37Aspect2",
    transform: "translate(7.031)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S37Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.447,
    cy: 7.5,
    rx: 7.447,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.447,
    cy: 7.5,
    rx: 6.697,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS37Aspect1",
    transform: "translate(22.002 0.079)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S37Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.447,
    cy: 7.5,
    rx: 7.447,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.447,
    cy: 7.5,
    rx: 6.697,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS46",
    className: "tooltip",
    transform: "translate(228.777 173.235) rotate(179.714)",
    "edge-id": "NOQ_SG_S46"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS46Label",
    transform: "translate(33.431 16.175) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S46Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-46")), /*#__PURE__*/React.createElement("g", {
    id: "SGS46Aspect2",
    transform: "translate(15 0.079)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S46Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS46Aspect1",
    transform: "translate(30.078 0.158)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S46Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS46Aspect3",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S46Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS12",
    className: "tooltip",
    transform: "translate(905.584 149.275) rotate(-0.286)",
    "edge-id": "NOQ_SG_S12"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS12Label",
    transform: "translate(8.961 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S12Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-12")), /*#__PURE__*/React.createElement("g", {
    id: "SGS12Aspect1",
    transform: "translate(0 11.983)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S12Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.204,
    cy: 7.5,
    rx: 7.204,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.204,
    cy: 7.5,
    rx: 6.454,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS12Aspect3",
    transform: "translate(14.484 12.062)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S12Aspect3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.204,
    cy: 7.5,
    rx: 7.204,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.204,
    cy: 7.5,
    rx: 6.454,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS2",
    className: "tooltip",
    transform: "translate(1376.508 181.082) rotate(179.714)",
    "edge-id": "NOQ_SG_S2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS2Label",
    transform: "translate(27.842 25) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-2")), /*#__PURE__*/React.createElement("g", {
    id: "SGS2Aspect3",
    transform: "translate(0 6.926)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S2Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS2Aspect1",
    transform: "translate(15.078 7.004)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S2Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-3",
    "data-name": "POLES",
    transform: "translate(29.342)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-3",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-3",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS3",
    className: "tooltip",
    transform: "translate(1383.586 250.11) rotate(-0.286)",
    "edge-id": "NOQ_SG_S3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS3Label",
    transform: "translate(13.921 27.157)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-3")), /*#__PURE__*/React.createElement("g", {
    id: "SGS3Aspect2",
    transform: "translate(15.078 0.079)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S3Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS3Aspect1",
    transform: "translate(30.078 0.157)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S3Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS3Aspect3",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S3Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS39",
    className: "tooltip",
    transform: "translate(459.99 312.43) rotate(-0.286)",
    "edge-id": "NOQ_SG_S39"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS39Label",
    transform: "translate(0 26.073)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S39Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-39")), /*#__PURE__*/React.createElement("g", {
    id: "SGS39Aspect2",
    transform: "translate(2.035)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S39Aspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS39Aspect1",
    transform: "translate(17.113 0.078)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S39Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGSDD",
    className: "tooltip",
    transform: "translate(52.586 182.103) rotate(179.714)",
    "edge-id": "NOQ_SG_SDD"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGSDDLabel",
    transform: "translate(30.999 25.042) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SDDLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DD")), /*#__PURE__*/React.createElement("g", {
    id: "SGSDDAspect3",
    transform: "translate(15.078 6.959)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_SDDAspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSDDAspect2",
    transform: "translate(30.156 7.038)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_SDDAspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSDDAspect1",
    transform: "translate(0 6.88)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_SDDAspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-4",
    "data-name": "POLES",
    transform: "translate(44.42)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-4",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-4",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGSUD",
    className: "tooltip",
    transform: "translate(1573.926 242.352) rotate(-0.286)",
    "edge-id": "NOQ_SG_SUD"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGSUDLabel",
    transform: "translate(14.004 32.411)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_SUDLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "UD")), /*#__PURE__*/React.createElement("g", {
    id: "SGSUDAspect3",
    transform: "translate(15.078 6.333)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_SUDAspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSUDAspect2",
    transform: "translate(30.156 6.412)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_SUDAspect2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGSUDAspect1",
    transform: "translate(0 6.254)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_SUDAspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-5",
    "data-name": "POLES",
    transform: "translate(45.268)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-5",
    "data-name": "POLES1",
    y2: 13.952,
    transform: "translate(7.972)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-5",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0 13.883)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS16",
    className: "tooltip",
    transform: "translate(737.474 0.157) rotate(-0.286)",
    "edge-id": "NOQ_SG_S16"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS16Label",
    transform: "translate(6.594 11)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S16Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-16")), /*#__PURE__*/React.createElement("g", {
    id: "SGS16Aspect1",
    transform: "translate(0 14.044)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S16Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.481,
    cy: 7.5,
    rx: 7.481,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.481,
    cy: 7.5,
    rx: 6.731,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS16Aspect2",
    transform: "translate(15.041 14.123)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S16Aspect2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.481,
    cy: 7.5,
    rx: 7.481,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.481,
    cy: 7.5,
    rx: 6.731,
    ry: 6.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS47",
    className: "tooltip",
    transform: "translate(169.24 274.841) rotate(179.714)",
    "edge-id": "NOQ_SG_S47"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS47Label",
    transform: "translate(30.728 3) rotate(180)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S47Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-47")), /*#__PURE__*/React.createElement("g", {
    id: "SGS47Aspect1",
    transform: "translate(8.119 13.192)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S47Aspect1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS47Aspect3",
    transform: "translate(23.197 13.271)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S47Aspect3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "POLES-6",
    "data-name": "POLES",
    transform: "translate(0 14.996)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "POLES1-6",
    "data-name": "POLES1",
    x1: 0.065,
    y2: 16.584,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "POLES2-6",
    "data-name": "POLES2",
    x2: 7.851,
    transform: "translate(0.101 6.976)",
    fill: "none",
    stroke: "#6c7091",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SGS35",
    className: "tooltip",
    transform: "translate(435.741 245.43) rotate(-0.286)",
    "edge-id": "NOQ_SG_S35"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SGS35Label",
    transform: "translate(0 27.104)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_SG_S35Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S-35")), /*#__PURE__*/React.createElement("g", {
    id: "SGS35Aspect3",
    transform: "translate(2.033)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S35Aspect3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.553,
    cy: 7.5,
    rx: 7.553,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.553,
    cy: 7.5,
    rx: 6.803,
    ry: 6.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SGS35Aspect1",
    transform: "translate(17.218 0.078)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 1.5,
    "edge-id-selector": "NOQ_SG_S35Aspect1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.553,
    cy: 7.5,
    rx: 7.553,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.553,
    cy: 7.5,
    rx: 6.803,
    ry: 6.75,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Stationinfo",
    transform: "translate(824.355 20)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "StationInfoenglish",
    transform: "translate(35.903 32)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "NirmalaUI, Nirmala UI",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0906\u0932\u093F\u092A\u0941\u0930\u0926\u094D\u0935\u093E\u0930")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H180",
    transform: "translate(13.645 49.216)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "StationInfo-2",
    "data-name": "StationInfo",
    transform: "translate(0 90.431)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New Alipurduar"))), /*#__PURE__*/React.createElement("g", {
    id: "Legend",
    transform: "translate(1394.55 723.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegend"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PMLegendLabel",
    transform: "translate(8.299 13.078)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "POINT MACHINE")), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormal",
    transform: "translate(8.299 19.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendNormalIndicator",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#21e074",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.544,
    cy: 7.694,
    rx: 7.544,
    ry: 7.694,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.544,
    cy: 7.694,
    rx: 5.544,
    ry: 5.694,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendNormalLabel",
    transform: "translate(24.142 10.769)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NORMAL"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverse",
    transform: "translate(8.299 37.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PMLegendReverseIndicator",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0088d1",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.544,
    cy: 7.694,
    rx: 7.544,
    ry: 7.694,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.544,
    cy: 7.694,
    rx: 5.544,
    ry: 5.694,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendReverseLabel",
    transform: "translate(22.633 10)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REVERSE"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendHr",
    transform: "translate(9 53.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr1",
    d: "M7.871,15.116C3.639,12.1,1.419,9.352.509,7.054-1.93.9,5.036-2.049,7.871,1.586c2.835-3.635,9.8-.69,7.362,5.468C14.323,9.352,12.1,12.1,7.871,15.116Z",
    transform: "translate(0 2.66)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PMLegendHr2",
    d: "M-.094-.755H3.881L5.527-3.307,7.664,1.518,9.2-.755l5.353-.006",
    transform: "translate(0.632 10.587)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    id: "PMLegendFailureLabel",
    transform: "translate(21.654 10)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FAILURE"))), /*#__PURE__*/React.createElement("g", {
    id: "PMLegendCanvas",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.06,
    height: 83.863,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 93.06,
    height: 81.863,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegend",
    transform: "translate(131.273)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TCLegendLabel",
    transform: "translate(16.598 13.078)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TRACK CIRCUIT")), /*#__PURE__*/React.createElement("g", {
    id: "TCFreeLegendGroup",
    transform: "translate(7.922 21.923)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFreeLegendIndicator",
    x2: 52.811,
    transform: "translate(0 7.309)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFreeLegendLabel",
    transform: "translate(58.469 10)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FREE"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOccupiedLegendGroup",
    transform: "translate(7.922 39.576)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOccupiedLegendIndicator",
    x2: 52.811,
    transform: "translate(0 7.309)",
    fill: "none",
    stroke: "#e77e00",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOccupiedLegendLabel",
    transform: "translate(58.033 10)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OCCUPIED"))), /*#__PURE__*/React.createElement("g", {
    id: "TCFailureLLegendGroup",
    transform: "translate(7.922 55.81)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCFailureLegendIndicator",
    x2: 52.811,
    transform: "translate(0 7.309)",
    fill: "none",
    stroke: "red",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCFailureLLegendLabel",
    transform: "translate(59.601 10)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FAILURE"))), /*#__PURE__*/React.createElement("g", {
    id: "TCLegendCanvas",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.957,
    height: 83.863,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 117.957,
    height: 81.863,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "LCG",
    transform: "translate(352 107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89A",
    className: "tooltip",
    transform: "translate(792 2)",
    "edge-id": "NOQ_LCG_NN89A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89AContent",
    "edge-id-selector": "NOQ_LCG_NN89AContent"
  }, /*#__PURE__*/React.createElement("line", {
    id: "LCGNN89Line",
    x1: 3,
    y2: 308,
    transform: "translate(64 71.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(1.747 13)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CONTROL_301",
    "data-name": "CONTROL 301",
    transform: "translate(9.909 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CONTROL 301")), /*#__PURE__*/React.createElement("text", {
    id: "GATE_NO._NN-89B",
    "data-name": "GATE NO. NN-89B",
    transform: "translate(0 27)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GATE NO. NN-89B"))), /*#__PURE__*/React.createElement("line", {
    id: "LCGNN89Line-2",
    "data-name": "LCGNN89Line",
    x1: 3,
    y2: 308,
    transform: "translate(27.5 71.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1-2",
    "data-name": "Rectangle 1",
    transform: "translate(0 11)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 56,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 96,
    height: 54,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CHR",
    transform: "translate(130.053 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CHR")), /*#__PURE__*/React.createElement("text", {
    id: "EMRSR",
    transform: "translate(99.023 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EMRSR"))), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89ABoomBClose",
    transform: "translate(13 57)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN89ABoomBClose"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89ABoomBOpen",
    transform: "translate(44 57)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN89ABoomBOpen"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89AEMRSR",
    transform: "translate(104 12)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN89AEMRSR"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89ACHR",
    transform: "translate(126 12)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN89ACHR"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89ABoomAClose",
    transform: "translate(17 424)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN89ABoomAClose"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN89ABoomAOpen",
    transform: "translate(51 424)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN89ABoomAOpen"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90A",
    className: "tooltip",
    "edge-id": "NOQ_LCG_NN90A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90ABoomAClose",
    transform: "translate(18 425)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN90ABoomAClose"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90ABoomAOpen",
    transform: "translate(55 424)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN90ABoomAOpen"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90AEMRSR",
    transform: "translate(115 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN90AEMRSR"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90ACHR",
    transform: "translate(137 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN90ACHR"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90ABoomBClose",
    transform: "translate(16 54)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN90ABoomBClose"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90ABoomBOpen",
    transform: "translate(51 54)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_LCG_NN90ABoomBOpen"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4.5,
    ry: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 4,
    rx: 4,
    ry: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LCGNN90AContent",
    "edge-id-selector": "NOQ_LCG_NN90AContent"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(8.747 13)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CONTROL_302",
    "data-name": "CONTROL 302",
    transform: "translate(9.909 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CONTROL 302")), /*#__PURE__*/React.createElement("text", {
    id: "GATE_NO._NN-90B",
    "data-name": "GATE NO. NN-90B",
    transform: "translate(0 27)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GATE NO. NN-90B"))), /*#__PURE__*/React.createElement("line", {
    id: "LCGNN90Line",
    y2: 317,
    transform: "translate(55 65)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(0 11)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 54,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 108,
    height: 52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    transform: "translate(0 382)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 54,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 108,
    height: 52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(4.83 382)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CONTROL_302-2",
    "data-name": "CONTROL 302",
    transform: "translate(9.826 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CONTROL 302")), /*#__PURE__*/React.createElement("text", {
    id: "GATE_NO._NN-90A",
    "data-name": "GATE NO. NN-90A",
    transform: "translate(0 27)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GATE NO. NN-90A"))), /*#__PURE__*/React.createElement("line", {
    id: "LCGNN90ALine",
    x1: 1,
    y2: 317,
    transform: "translate(76.5 65.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: 3,
    "edge-id-selector": "NOQ_LCG_NN90ALine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    transform: "translate(785 382)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 54,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 108,
    height: 52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(793.83 388)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CONTROL_301-2",
    "data-name": "CONTROL 301",
    transform: "translate(9.826 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CONTROL 301")), /*#__PURE__*/React.createElement("text", {
    id: "GATE_NO._NN-89A",
    "data-name": "GATE NO. NN-89A",
    transform: "translate(0 27)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GATE NO. NN-89A"))), /*#__PURE__*/React.createElement("text", {
    id: "CHR-2",
    "data-name": "CHR",
    transform: "translate(141.053 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CHR")), /*#__PURE__*/React.createElement("text", {
    id: "EMRSR-2",
    "data-name": "EMRSR",
    transform: "translate(112.023 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EMRSR")))), /*#__PURE__*/React.createElement("g", {
    id: "LCGContent",
    transform: "translate(5.949 42)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CLOSED",
    transform: "translate(0 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CLOSED")), /*#__PURE__*/React.createElement("text", {
    id: "OPEN",
    transform: "translate(39.287 9)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OPEN")), /*#__PURE__*/React.createElement("text", {
    id: "CLOSED-2",
    "data-name": "CLOSED",
    transform: "translate(789 12)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CLOSED")), /*#__PURE__*/React.createElement("text", {
    id: "OPEN-2",
    "data-name": "OPEN",
    transform: "translate(823.287 12)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OPEN")), /*#__PURE__*/React.createElement("text", {
    id: "CLOSED-3",
    "data-name": "CLOSED",
    transform: "translate(4 380)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CLOSED")), /*#__PURE__*/React.createElement("text", {
    id: "OPEN-3",
    "data-name": "OPEN",
    transform: "translate(43.287 380)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OPEN")), /*#__PURE__*/React.createElement("text", {
    id: "CLOSED-4",
    "data-name": "CLOSED",
    transform: "translate(792 383)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CLOSED")), /*#__PURE__*/React.createElement("text", {
    id: "OPEN-4",
    "data-name": "OPEN",
    transform: "translate(831.287 383)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OPEN")))), /*#__PURE__*/React.createElement("g", {
    id: "AXL",
    transform: "translate(1303 580.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXLNBS_DN1",
    className: "tooltip",
    transform: "translate(4.505 45)",
    "edge-id": "NOQ_AC_DNBPAC3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLNBS_DN1Label",
    transform: "translate(0 29)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_AC_DNBPAC3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NBS_DN1")), /*#__PURE__*/React.createElement("g", {
    id: "AXLNBS_DN1Icon",
    transform: "translate(18.495)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_AC_DNBPAC3Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLNBS_DN2",
    className: "tooltip",
    transform: "translate(60.505 45)",
    "edge-id": "NOQ_AC_DNBPAC4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLNBS_DN2Label",
    transform: "translate(0 29)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_AC_DNBPAC4Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NBS_DN2")), /*#__PURE__*/React.createElement("g", {
    id: "AXLNBS_DN2Icon",
    transform: "translate(16.495)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_AC_DNBPAC4Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLNBS_UP1",
    className: "tooltip",
    transform: "translate(115.346 45)",
    "edge-id": "NOQ_AC_UPBPAC3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLNBS_UP1Label",
    transform: "translate(0 29)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_AC_UPBPAC3Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NBS_UP1")), /*#__PURE__*/React.createElement("g", {
    id: "AXLNBS_UP1Icon",
    transform: "translate(16.654)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_AC_UPBPAC3Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLNBS_UP2",
    className: "tooltip",
    transform: "translate(170.346 45)",
    "edge-id": "NOQ_AC_UPBPAC4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLNBS_UP2Label",
    transform: "translate(0 29)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_AC_UPBPAC4Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NBS_UP2")), /*#__PURE__*/React.createElement("g", {
    id: "AXLNBS_UP2Icon",
    transform: "translate(17.654)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_AC_UPBPAC4Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLSMTA_DN1",
    className: "tooltip",
    transform: "translate(224.727 45)",
    "edge-id": "NOQ_AC_DNBPAC1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLSMTA_DN1Label",
    transform: "translate(0 29)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_AC_DNBPAC1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SMTA_DN1")), /*#__PURE__*/React.createElement("g", {
    id: "AXLSMTA_DN1Icon",
    transform: "translate(14.273)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_AC_DNBPAC1Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLSMTA_DN2",
    className: "tooltip",
    transform: "translate(287.727 45)",
    "edge-id": "NOQ_AC_DNBPAC2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLSMTA_DN2Label",
    transform: "translate(0 29)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_AC_DNBPAC2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SMTA_DN2")), /*#__PURE__*/React.createElement("g", {
    id: "AXLSMTA_DN2Icon",
    transform: "translate(11.273)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_AC_DNBPAC2Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLSMTA_UP1",
    className: "tooltip",
    transform: "translate(350.567 45)",
    "edge-id": "NOQ_AC_UPBPAC1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXLSMTA_UP1Label",
    transform: "translate(0 29)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_AC_UPBPAC1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SMTA_UP1")), /*#__PURE__*/React.createElement("g", {
    id: "AXLSMTA_UP1Icon",
    transform: "translate(8.433)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_AC_UPBPAC1Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "AXLSMTA_UP2",
    className: "tooltip",
    transform: "translate(412.567 45)",
    "edge-id": "NOQ_AC_UPBPAC2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "AXSMTA_UP2Label",
    transform: "translate(0 29)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SMTA_UP2")), /*#__PURE__*/React.createElement("g", {
    id: "AXLSMTA_UP2Icon",
    transform: "translate(8.433)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    "edge-id-selector": "NOQ_AC_UPBPAC2Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "AXLE_COUNTER",
    "data-name": "AXLE COUNTER",
    transform: "translate(162.523 30)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AXLE COUNTER")), /*#__PURE__*/React.createElement("g", {
    id: "AXLRectangle",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 483,
    height: 109,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 480,
    height: 106,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TrackCircuit",
    "data-name": "Track Circuit",
    transform: "translate(130.5 171.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TCC46T",
    className: "tooltip",
    transform: "translate(116 160.5)",
    "edge-id": "NOQ_TC_C46T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC46TLine",
    x2: 50,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_C46TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC46TLabel",
    transform: "translate(9.698 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_C46TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C46T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC46T1T",
    className: "tooltip",
    transform: "translate(169 160.5)",
    "edge-id": "NOQ_TC_46T1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC46T1TLine",
    x2: 52,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_46T1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC46T1Label",
    transform: "translate(10.023 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "46T1"))), /*#__PURE__*/React.createElement("g", {
    id: "TC46T2T",
    className: "tooltip",
    transform: "translate(224 160.5)",
    "edge-id": "NOQ_TC_46T2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC46T2TLine",
    x2: 84,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_46T2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC46T2TLabel",
    transform: "translate(15.023 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_46T2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "46T2"))), /*#__PURE__*/React.createElement("g", {
    id: "TC132T",
    className: "tooltip",
    transform: "translate(311 146)",
    "edge-id": "NOQ_TC_132T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC132TLine",
    x2: 80,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_132TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC132TLabel",
    transform: "translate(16.023 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_132TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "132T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC133T",
    className: "tooltip",
    transform: "translate(394 160)",
    "edge-id": "NOQ_TC_133T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC133TLine",
    x2: 67,
    transform: "translate(0 0.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_133TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC133TLabel",
    transform: "translate(21.023 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_133TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "133T"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOC2T",
    className: "tooltip",
    transform: "translate(464 145)",
    "edge-id": "NOQ_TC_OC2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOC2TLine",
    x2: 224,
    transform: "translate(0 15.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OC2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOC2TLabel",
    transform: "translate(108.559 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OC2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OC2T"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOC1T",
    className: "tooltip",
    transform: "translate(691 160.5)",
    "edge-id": "NOQ_TC_OC1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOC1TLine",
    x2: 294,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OC1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOC1TLabel",
    transform: "translate(41.559 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OC1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OC1T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC103T",
    className: "tooltip",
    transform: "translate(988 160.5)",
    "edge-id": "NOQ_TC_103T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC103TLine",
    x2: 181,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_103TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC103TLabel",
    transform: "translate(118.023 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_103TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "103T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC102T",
    className: "tooltip",
    "data-name": "102T",
    transform: "translate(1172 146)",
    "edge-id": "NOQ_TC_102T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC102TLine",
    x2: 82,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_102TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC102TLabel",
    transform: "translate(23.023 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_102TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "102T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC2T",
    className: "tooltip",
    transform: "translate(1356 146)",
    "edge-id": "NOQ_TC_2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC2TLine",
    x2: 71,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC2TLabel",
    transform: "translate(49.312 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC2AT",
    className: "tooltip",
    transform: "translate(1257 145)",
    "edge-id": "NOQ_TC_2AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC2ATLine",
    x2: 96,
    transform: "translate(0 15.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_2ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC2ATLabel",
    transform: "translate(39.832 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_2ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2AT"))), /*#__PURE__*/React.createElement("g", {
    id: "TC47T",
    className: "tooltip",
    transform: "translate(93 206)",
    "edge-id": "NOQ_TC_47T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC47TLine",
    x2: 57,
    transform: "translate(0 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_47TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC47TLabel",
    transform: "translate(19.168 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_47TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "47T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC47AT",
    className: "tooltip",
    transform: "translate(153 206)",
    "edge-id": "NOQ_TC_47AT"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC47ATLine",
    x2: 84,
    transform: "translate(0 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_47ATLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC47ATLabel",
    transform: "translate(19.687 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_47ATLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "47AT"))), /*#__PURE__*/React.createElement("g", {
    id: "TC131T",
    className: "tooltip",
    transform: "translate(239 220.5)",
    "edge-id": "NOQ_TC_131T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC131TLine",
    x2: 109,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_131TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC131TLabel",
    transform: "translate(5.023 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_131TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "131T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC137T",
    className: "tooltip",
    transform: "translate(351 206)",
    "edge-id": "NOQ_TC_137T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC137TLine",
    x2: 82,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_137TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC137TLabel",
    transform: "translate(41.308 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_137TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "137T"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOA2T",
    className: "tooltip",
    transform: "translate(436 220)",
    "edge-id": "NOQ_TC_OA2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOA2TLine",
    x2: 264,
    transform: "translate(0 0.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OA2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOA2TLabel",
    transform: "translate(90.549 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OA2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OA2T"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOA1T",
    className: "tooltip",
    transform: "translate(703 220)",
    "edge-id": "NOQ_TC_OA1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOA1TLine",
    x2: 168,
    transform: "translate(0 0.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OA1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOA1TLabel",
    transform: "translate(64.549 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OA1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OA1T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC107T",
    className: "tooltip",
    transform: "translate(874 205)",
    "edge-id": "NOQ_TC_107T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC107TLine",
    x2: 265,
    transform: "translate(0 15.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_107TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC107TLabel",
    transform: "translate(92.879 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_107TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "107T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC101T",
    className: "tooltip",
    transform: "translate(1142 220.5)",
    "edge-id": "NOQ_TC_101T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC101TLine",
    x2: 139,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_101TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC101TLabel",
    transform: "translate(56.023 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_101TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "101T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC3T2",
    className: "tooltip",
    transform: "translate(1284 206)",
    "edge-id": "NOQ_TC_3T2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC3T2Line",
    x2: 83,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_3T2Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC3T2Label",
    transform: "translate(27.595 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_3T2Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "3T2"))), /*#__PURE__*/React.createElement("g", {
    id: "TC3T1",
    className: "tooltip",
    transform: "translate(1370 205)",
    "edge-id": "NOQ_TC_3T1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC3T1Line",
    x2: 69,
    transform: "translate(0 15.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_3T1Line"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC3T1Label",
    transform: "translate(21.168 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_3T1Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3T1"))), /*#__PURE__*/React.createElement("g", {
    id: "TCC3T",
    className: "tooltip",
    transform: "translate(1441 206)",
    "edge-id": "NOQ_TC_C3T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCC3TLine",
    x2: 76,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_C3TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCC3TLabel",
    transform: "translate(48.843 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_C3TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C3T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC138T",
    className: "tooltip",
    transform: "translate(340.023 285.5)",
    "edge-id": "NOQ_TC_138T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC138TLine",
    x2: 84,
    transform: "translate(36.977)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_138TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC138TLabel",
    transform: "translate(0 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_138TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "138T"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOB2T",
    className: "tooltip",
    transform: "translate(464 270)",
    "edge-id": "NOQ_TC_OB2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOB2TLine",
    x2: 167,
    transform: "translate(0 15.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OB2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOB2TLabel",
    transform: "translate(43.607 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OB2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "OB2T"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOB1T",
    className: "tooltip",
    transform: "translate(619.464 270.5)",
    "edge-id": "NOQ_TC_OB1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOB1TLine",
    x2: 95,
    transform: "translate(14.536 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OB1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOB1TLabel",
    transform: "translate(0 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OB1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "OB1T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC115T",
    className: "tooltip",
    transform: "translate(732 271)",
    "edge-id": "NOQ_TC_115T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC115TLine",
    x2: 95,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_115TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC115TLabel",
    transform: "translate(0.5 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_115TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "115/116T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC108T",
    className: "tooltip",
    transform: "translate(830 285.5)",
    "edge-id": "NOQ_TC_108T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC108TLine",
    x2: 95,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_108TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC108TLabel",
    transform: "translate(23.023 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_108TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "108T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC109T",
    className: "tooltip",
    transform: "translate(926.569 271)",
    "edge-id": "NOQ_TC_109T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC109TLine",
    x2: 49,
    transform: "translate(1.431 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_109TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC109TLabel",
    transform: "translate(0 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_109TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "109T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC112T",
    className: "tooltip",
    transform: "translate(646 405.5)",
    "edge-id": "NOQ_TC_112T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC112TLine",
    x2: 160,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_112TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC112TLabel",
    transform: "translate(41.115 14.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_112TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "112T"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOE1T",
    className: "tooltip",
    transform: "translate(704 14)",
    "edge-id": "NOQ_TC_OE1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOE1TLine",
    x2: 125,
    y2: 0.5,
    transform: "translate(0 0.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OE1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOE1TLabel",
    transform: "translate(57.97 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OE1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OE1T"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOE2T",
    className: "tooltip",
    transform: "translate(618)",
    "edge-id": "NOQ_TC_OE2T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOE2TLine",
    x2: 83,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OE2TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOE2TLabel",
    transform: "translate(21.97 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OE2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OE2T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC134T",
    className: "tooltip",
    transform: "translate(423 62)",
    "edge-id": "NOQ_TC_134T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC134TLine",
    x2: 57,
    transform: "translate(39 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_134TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC134TLabel",
    transform: "translate(44.023 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_134TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "134T")), /*#__PURE__*/React.createElement("line", {
    id: "TC134TLine-2",
    "data-name": "TC134TLine",
    x2: 39,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_134TLine-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TC135T",
    className: "tooltip",
    transform: "translate(545 60)",
    "edge-id": "NOQ_TC_135T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC135TLine",
    x2: 57,
    transform: "translate(0 16.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_135TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC135TLabel",
    transform: "translate(11.569 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_135TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "135T"))), /*#__PURE__*/React.createElement("g", {
    id: "TCOD2T",
    className: "tooltip",
    transform: "translate(605 61)",
    "edge-id": "NOQ_TC_OD2T"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TCOD2TLabel",
    transform: "translate(33.733 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OD2TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "OD2T")), /*#__PURE__*/React.createElement("line", {
    id: "TCOD2TLine",
    x2: 124,
    transform: "translate(0 15.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OD2TLine"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TCOD1T",
    className: "tooltip",
    transform: "translate(732 76.5)",
    "edge-id": "NOQ_TC_OD1T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TCOD1TLine",
    x2: 152,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_OD1TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TCOD1TLabel",
    transform: "translate(64.02 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_OD1TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OD1T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC105T",
    className: "tooltip",
    transform: "translate(886 76.5)",
    "edge-id": "NOQ_TC_105T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC105TLine",
    x2: 154,
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_105TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC105TLabel",
    transform: "translate(70.569 12.5)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_105TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "105T"))), /*#__PURE__*/React.createElement("g", {
    id: "TC104T",
    className: "tooltip",
    transform: "translate(1043 61)",
    "edge-id": "NOQ_TC_104T"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC104TLine",
    x2: 83,
    transform: "translate(0 15.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_104TLine"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TC104TLabel",
    transform: "translate(43.023 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans, Open Sans",
    "edge-id-selector": "NOQ_TC_104TLabel"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "104T")), /*#__PURE__*/React.createElement("line", {
    id: "TC104TLine-2",
    "data-name": "TC104TLine",
    x2: 18,
    transform: "translate(85 15)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3,
    "edge-id-selector": "NOQ_TC_104TLine-2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "TC107TLine-2",
    "data-name": "TC107TLine",
    d: "M-3.733,8.072,3.658,0h260.6",
    transform: "translate(1000.746 285.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TCC46TLine-2",
    "data-name": "TCC46TLine",
    x2: 114,
    transform: "translate(0 160.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC47TLine-2",
    "data-name": "TC47TLine",
    x2: 92,
    transform: "translate(0 221)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC138TLine-2",
    "data-name": "TC138TLine",
    x2: 70,
    transform: "translate(305 285.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC2TLine-2",
    "data-name": "TC2TLine",
    x2: 154,
    transform: "translate(1519 220.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC2TLine-3",
    "data-name": "TC2TLine",
    x2: 239.5,
    transform: "translate(1428.5 160.5)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Poles-7",
    "data-name": "Poles",
    transform: "translate(129.5 246.36)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES",
    y1: 10,
    transform: "translate(423.5 -2)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-2",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(0 82)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-3",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(0 142.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-4",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(305 207.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-5",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(647 326.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-6",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(1673 142.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-7",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(1670 82.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-8",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(1146 -2.596)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-9",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(1266 206.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 123,
    transform: "translate(647 278.404)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 162,
    transform: "translate(647 398.404)",
    fill: "none",
    stroke: "#6c7091",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TC125AXTPOLES-10",
    "data-name": "TC125AXTPOLES",
    d: "M0,10H5.649V-.381",
    transform: "translate(1422.351 81.595)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-11",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(771 274.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-12",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(647 393.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "TC125AXTPOLES-13",
    "data-name": "TC125AXTPOLES",
    y1: 10,
    transform: "translate(647 273.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TC125AXTPOLES-14",
    "data-name": "TC125AXTPOLES",
    d: "M0,10H5.649V-.381",
    transform: "translate(1150 207.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TC125AXTPOLES-15",
    "data-name": "TC125AXTPOLES",
    d: "M5.649,10H0V-.381",
    transform: "translate(116 82.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TC125AXTPOLES-16",
    "data-name": "TC125AXTPOLES",
    d: "M5.649,10H0V-.381",
    transform: "translate(94 142.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TC125AXTPOLES-17",
    "data-name": "TC125AXTPOLES",
    d: "M5.649,10H0V-.381",
    transform: "translate(377 207.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TC125AXTPOLES-18",
    "data-name": "TC125AXTPOLES",
    d: "M0,10H5.649V-.381",
    transform: "translate(1513 141.404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TC125AXTPOLES-19",
    "data-name": "TC125AXTPOLES",
    d: "M5.649,10H0V-.381",
    transform: "translate(462 -1.619)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "TC125AXTPOLES-20",
    "data-name": "TC125AXTPOLES",
    d: "M0,10H5.649V-.381",
    transform: "translate(1122.351 -2.596)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bitcomm_logo",
    transform: "translate(44.305 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(36.292 0.741) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M50.3,50.3,1.28,49.017,0,0,49.017,1.28Z",
    transform: "translate(0.514 0.514)",
    fill: "#0e86d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1.027,1.027,2.281,49.043,50.3,50.3,49.043,2.281,1.027,1.027M0,0,50.018,1.306l1.306,50.018L1.306,50.018Z",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(19.899 19.74)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 17.799,
    ry: 18.753,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.799,
    cy: 18.753,
    rx: 15.299,
    ry: 16.253,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1-3",
    "data-name": "Path 1",
    d: "M.568-1.031h0s8.95,7.449,10.283,9.924a47.609,47.609,0,0,1,2.316,5.086",
    transform: "translate(10.027 30.117)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2-2",
    "data-name": "Path 2",
    transform: "translate(16.806 22.439) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M0,5.122.312,0l14.3.812L16.9,5.16l-1.889.027Z",
    transform: "translate(0.512 0.507)",
    fill: "#0e86d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1.277,1.012,1.029,5.15,15.5,5.208l1.131-.014-1.8-3.409L1.277,1.012M.371,0,15.409.854l2.778,5.284-2.639.033L0,6.108Z",
    fill: "#0e86d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3",
    "data-name": "Path 3",
    transform: "matrix(0.616, -0.788, 0.788, 0.616, 8.229, 30.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M3.907.459,0,.5.014,0,3.907.366Z",
    transform: "translate(0.501 0.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M.055,0,4.892.455v1L0,1.506Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M44,44",
    transform: "translate(-3.024 31.506)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2-2",
    "data-name": "Group 2",
    transform: "translate(0.695 1.481)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 31.584)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 26.649)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(9.368 21.714)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    transform: "translate(70.484) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-2",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-2",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-2",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-2",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-2",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-2",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-2",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4-2",
    "data-name": "Group 4",
    transform: "translate(70.953 73.532) rotate(180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-3",
    "data-name": "Line 2",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(0 32.571)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-3",
    "data-name": "Line 3",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(4.684 27.636)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-3",
    "data-name": "Line 4",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(8.431 22.701)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-3",
    "data-name": "Line 5",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(13.115 17.766)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-3",
    "data-name": "Line 6",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(17.799 12.831)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-3",
    "data-name": "Line 8",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(30.913)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-3",
    "data-name": "Line 9",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(22.482 7.896)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-3",
    "data-name": "Line 10",
    x2: 3.747,
    y2: 3.948,
    transform: "translate(26.23 3.948)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(34.887 37.506) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2-4",
    "data-name": "Line 2",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(0 29.977)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-4",
    "data-name": "Line 3",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(4.935 25.293)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-4",
    "data-name": "Line 4",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(9.87 20.609)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-4",
    "data-name": "Line 5",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(13.818 16.862)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-4",
    "data-name": "Line 6",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(18.753 12.178)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7-3",
    "data-name": "Line 7",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8-4",
    "data-name": "Line 8",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(32.571)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-4",
    "data-name": "Line 9",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(23.688 7.494)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10-4",
    "data-name": "Line 10",
    x2: 3.948,
    y2: 3.747,
    transform: "translate(27.636 3.747)",
    fill: "none",
    stroke: "#0e86d4",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("text", {
    id: "GHY_END",
    "data-name": "GHY END",
    transform: "translate(106.753 251.994)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GHY END")), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M26.084-5.689v2.731L6.169-3.047V2.375L-9.124-6.357l.4-.189L-7.6-7l.8-.325",
    transform: "translate(77.857 250.709)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M26.1,4.956V-1.9H6.169V-7.328L-7.145,1.111l-.356.175-.337.179-.336.176-.384.344",
    transform: "translate(77.857 242.11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "NBS_END",
    "data-name": "NBS END",
    transform: "translate(1645.505 251.994)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NBS END")), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M-9.124.737V-1.994L10.791-1.9V-7.328L26.084,1.4l-.4.189-1.118.456-.8.325",
    transform: "translate(1745.868 244.144)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M-8.558-7.328v6.86H11.368V4.956L24.682-3.483l.356-.175.337-.179.336-.176.384-.344",
    transform: "translate(1745.291 250.132)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "SB_SM_PANEL",
    "data-name": "SB/ SM PANEL",
    transform: "translate(784.41 732.379)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SB/ SM PANEL")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(765 695.379)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 95,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 177,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(843 743.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M28.114,23.5H.886L14.5.967Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4-2",
    "data-name": "Path 4",
    d: "M14.5,1.934,1.773,23H27.228L14.5,1.934M14.5,0,29,24H0Z",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoqStation);
export default __webpack_public_path__ + "static/media/NOQ_Station.213a83eacb0c18ac3bf841110ea941d1.svg";
export { ForwardRef as ReactComponent };